/* Global shim for react-helmet-async.
 * react-helmet-async v2 has a broken client dispatcher under React 18: it strips
 * the shell's data-rh tags but fails to (re)emit page <meta> tags, and rAF-deferred
 * commits get starved on first load. This shim transparently swaps in the actively
 * maintained drop-in fork (@dr.pogodin/react-helmet) with synchronous commits.
 * Wired via craco webpack alias 'react-helmet-async$' -> this file, so all 53
 * existing `import { Helmet } from 'react-helmet-async'` statements keep working.
 */
import React from 'react';
import { Helmet as BaseHelmet, HelmetProvider } from '@dr.pogodin/react-helmet';

export const Helmet = (props) => <BaseHelmet {...props} defer={false} />;
export { HelmetProvider };
